import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6204bd78"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal-backdrop"
}
const _hoisted_2 = { class: "modal2" }
const _hoisted_3 = { class: "modal-header flex-row flex-align-center" }
const _hoisted_4 = { class: "text-center flex-1 modal-header-title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#333",
    d: "M14 12.461 8.3 6.772l5.234-5.233L12.006 0 6.772 5.234 1.54 0 0 1.539l5.234 5.233L0 12.006l1.539 1.528L6.772 8.3l5.69 5.7L14 12.461z"
  })
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "modal-body flex-row flex-wrap" }
const _hoisted_8 = { class: "table table-borderless" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { style: {"width":"100px"} }),
  /*#__PURE__*/_createElementVNode("td")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", { for: "app-home-title" }, "标题:")
  ])
], -1))
const _hoisted_11 = { class: "mb-1" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", { for: "app-home-title2" }, "二级标题:")
  ])
], -1))
const _hoisted_14 = { class: "mb-1" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", { for: "app-home-desc" }, "描述:")
  ])
], -1))
const _hoisted_17 = { class: "mb-1" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", { for: "app-home-button" }, "按钮:")
  ])
], -1))
const _hoisted_19 = { class: "mb-1" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", { for: "app-home-order" }, "排序:")
  ])
], -1))
const _hoisted_21 = { class: "mb-1" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", { for: "app-home-link" }, "链接:")
  ])
], -1))
const _hoisted_23 = { class: "mb-1" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", { for: "app-home-show" }, "是否显示:")
  ])
], -1))
const _hoisted_25 = { class: "mb-1 form-switch" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", { for: "app-home-image" }, "图片:")
  ])
], -1))
const _hoisted_27 = { class: "mb-1" }
const _hoisted_28 = {
  key: 2,
  id: "app-home-children"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-1 td-label-right" }, [
    /*#__PURE__*/_createElementVNode("label", { for: "app-home-image" }, "子分类:")
  ])
], -1))
const _hoisted_30 = { class: "flex-row flex-wrap mb-1" }
const _hoisted_31 = ["src", "onClick"]
const _hoisted_32 = { class: "modal-footer2 flex-row-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ImageUploader = _resolveComponent("ImageUploader")!
  const _component_AppHomeChildDialog = _resolveComponent("AppHomeChildDialog")!
  const _component_LoadingDialog = _resolveComponent("LoadingDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.item.type), 1),
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args))),
                class: "modal-header-close"
              }, _hoisted_6)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("table", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("tr", null, [
                  _hoisted_10,
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_11, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.item.title) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.item.title]
                      ])
                    ])
                  ])
                ]),
                (_ctx.item.type!=='栏目')
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_14, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.item.title2) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.item.title2]
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.item.type!=='栏目')
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                      _hoisted_16,
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_17, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.item.desc) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.item.desc]
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("tr", null, [
                  _hoisted_18,
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_19, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.item.button) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.item.button]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_20,
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_21, [
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.item.order) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.item.order]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_22,
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_23, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.item.link) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.item.link]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_24,
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_25, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        checked: "",
                        type: "checkbox",
                        role: "switch",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.item.show) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.item.show]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_26,
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_ImageUploader, {
                        src: _ctx.item.image,
                        onUpload: _ctx.imageUpload
                      }, null, 8, ["src", "onUpload"])
                    ])
                  ])
                ]),
                (_ctx.item.type === '内容' && _ctx.item.id)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_28, [
                      _hoisted_29,
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_30, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.children, (value, index) => {
                            return (_openBlock(), _createElementBlock("img", {
                              src: value.image,
                              key: index,
                              onClick: ($event: any) => (_ctx.openEditChildDialog(value)),
                              class: "image-preview-small"
                            }, null, 8, _hoisted_31))
                          }), 128)),
                          _createElementVNode("img", {
                            src: "/assets/image_preview_add.png",
                            class: "image-preview-small",
                            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.openAddAppHomeChildDialog && _ctx.openAddAppHomeChildDialog(...args)))
                          })
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
              }, "确定")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_AppHomeChildDialog, {
      show: _ctx.showAddDialog,
      item: _ctx.editing,
      onCancel: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showAddDialog=false)),
      onConfirm: _ctx.submitAppHomeChild
    }, null, 8, ["show", "item", "onConfirm"]),
    _createVNode(_component_LoadingDialog, { show: _ctx.showLoadingDialog }, null, 8, ["show"])
  ], 64))
}